export default __webpack_public_path__ + "static/petfriendly-fdbd35845dee186ab7d9de6532e82629.svg";